<!--suppress JSUnusedAssignment -->
<script lang="ts">
    import SentenceComp from './Sentence.svelte';
    import './clickEffect.css'
    import {moveSentenceToBeginning} from '$lib/utils/moveSentenceToBeginning';
    import type {UserWordsMapStore} from '$lib/classes/stores/get-user-words-map';
    import type {UserWord} from '$lib/classes/data/user-word';
    import type {Sentence} from '$lib/classes/data/sentence';
    import type {CurrentWord} from '$lib/stores/currentWord';
    import LastMarker from '$lib/components/browse/WordCard/Sentence/last-marker.svelte';

    export let currentWord: CurrentWord
    export let userWordsMap: UserWordsMapStore
    export let sentences: Sentence[]
    export let userWord: UserWord | undefined

    // MOVE savedSentence to beginning
    let savedSentenceId = userWord?.sentenceId

    if (savedSentenceId) {
        sentences = moveSentenceToBeginning(sentences, savedSentenceId)
    }

    // Lazy load&show SentencesList
    let sentencesCount = sentences.length
    let section = 1
    let sectionCount = 10 //NOTE will be doubled with first 'isIntersecting' event of lastMarker

    $: cutUntil = section * sectionCount < sentencesCount ? section * sectionCount : sentencesCount
    $: displaySentences = sentences.slice(0, cutUntil)

    function handleIntersecting() {
        section += 1
    }
</script>

<div id="sentences">

    {#each displaySentences as sentence, index (sentence.id)}
        <SentenceComp
                currentWord={currentWord}
                userWordsMap={userWordsMap}
                {sentence}
                {userWord}
        />
    {/each}

    <LastMarker onIntersecting={handleIntersecting}/>
</div>


<style>
    #sentences {
        position: relative;
        grid-column: 1/4;
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 0 0 3rem;
        /*border: 1px solid darkmagenta;*/
    }
</style>